export interface ProspectLossReasonDictionaryType {
  id: number;
  reason: string;
}

export enum ClientDetailsSegments {
  PREVIEW = 'PREVIEW',
  DEALS = 'DEALS',
  DOCS = 'DOCS',
  MULTIFORM = 'MULTIFORM',
  NOTES = 'NOTES',
  BIK = 'BIK',
  EKO = 'EKO',
  ACTIVITY = 'ACTIVITY',
  CLIENT_DATA = 'CLIENT_DATA',
  BIK_OLD = 'BIK_OLD',
}

export enum ClientDetailsTabs {
  PREVIEW = 0,
  DEALS,
  DOCS,
  MULTIFORM,
  ACTIVITY,
  BIK,
}

export enum UserDetailsSegments {
  AVAILABILITY = 'AVAILABILITY',
  USER_DATA = 'USER_DATA',
  AGENT_BUSINESS_CARD = 'AGENT_BUSINESS_CARD',
  DELEGATION_LIST = 'DELEGATION_LIST',
  CUSTOM_LOGO = 'CUSTOM_LOGO',
  BANKS_PERMISSION = 'BANKS_PERMISSION',
  HISTORY = 'HISTORY',
}

export enum DivisionDetailsSegments {
  DIVISION_DETAILS = 'DIVISION_DETAILS',
}

export enum DealDetailsSegments {
  PREVIEW = 'PREVIEW',
  PROCESS = 'PROCESS',
  DOCS = 'DOCS',
  NOTES = 'NOTES',
  REPORT = 'REPORT',
  EKO = 'EKO',
  ACTIVITY = 'ACTIVITY',
  DEAL_DATA = 'DEAL_DATA',
  MULTIFORM = 'MULTIFORM',
  STATUS = 'STATUS',
  CLIENTS = 'CLIENTS',
  LOAN_APPLICATIONS = 'LOAN_APPLICATIONS',
  DISCOUNTS = 'DISCOUNTS',
}

export enum DelegationListsSegments {
  NORMAL = 'NORMAL',
  PROSPECTS = 'PROSPECTS',
}

export type TabHeader<T> = {
  name: string;
  id?: string;
  type: T;
  condition?: boolean;
};

export type TabConfig<T> = TabHeader<T> & {
  onTab?: () => void;
  hasChanges?: boolean;
  onSaveAction?: () => Promise<void>;
  onUndoAction?: () => void;
};
